import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const K: React.FC = () => {
    const { t } = useLang('shp3.K');
    const sectionRef = useRef<HTMLDivElement>(null);
    const webpOrJpg = useWebpOrJpg('#shp3-K');
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.shp3-K .title');
        const desc = sectionRef.current?.querySelector('.shp3-K .desc');
        const img = sectionRef.current?.querySelector('.shp3-K .img');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
                img?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    img?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} shp3-K GtmModuleData-section`}
                id="shp3-K"
                data-section-id={'shp3-K'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="info">
                    <p className="title ani-1">{t('title')}</p>
                    <p className="desc ani-2">{t.rich('desc', { h: (a: string) => <span className="white">{a}</span> })}</p>
                </div>
                <div className="img ani-3">
                    <EcoImg
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760097713911/pc_AI%20TOU%20Mode.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760097743812/pc_AI.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760097734879/m_AI%20TOU%20Mode.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760097743660/m_AI.webp',
                        )}
                    />
                </div>
            </section>
        </>
    );
};

export default K;
